// extracted by mini-css-extract-plugin
export var numberInputContainer = "_80-0";
export var startPickingButton = "_80-1";